import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-crfct-instruction-dialog',
  templateUrl: './crfct-instruction-dialog.component.html',
  styleUrls: ['./crfct-instruction-dialog.component.css']
})
export class CrfctInstructionDialogComponent implements OnInit {

  constructor( public dialog: MatDialog,
               public dialogRef: MatDialogRef<CrfctInstructionDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
